import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Translate, withLocalize } from 'react-localize-redux';
import Icon, { IconSizes } from '../../components/foundations/Icon';
import Button from '../../components/atoms/Button';
import { TRANSLATION_KEY } from '../constants';
import { formatScheduleLabel } from '../utils';
import css from './AddMonitorBar.css';

const AddMonitorBar = ({
    onSubmit,
    scheduleCron,
    onScheduleClick,
    submitting = false,
    error = null,
    isEmptyVariant = false,
    initialValue = '',
    translate,
}) => {
    const [value, setValue] = useState(initialValue);

    const submit = async () => {
        if (!value.trim() || submitting) return;
        if (await onSubmit(value.trim())) setValue('');
    };
    const placeholderKey = isEmptyVariant ? 'EMPTY_STATE.PLACEHOLDER' : 'ADD_BAR.PLACEHOLDER';
    const addKey = isEmptyVariant ? 'EMPTY_STATE.ADD' : 'ADD_BAR.ADD';

    return (
        <div className={css.container}>
            <div className={classNames(css.bar, { [css.emptyVariant]: isEmptyVariant })}>
                <Icon name="sparkles" size={IconSizes.SMALL} interactive={false} />
                <input
                    className={css.input}
                    value={value}
                    placeholder={translate(`${TRANSLATION_KEY}.${placeholderKey}`)}
                    onChange={e => setValue(e.target.value)}
                    onKeyDown={e => e.key === 'Enter' && submit()}
                />
                <button type="button" className={css.scheduleChip} onClick={onScheduleClick}>
                    <Icon name="clock" size={IconSizes.X_SMALL} interactive={false} />
                    {formatScheduleLabel(scheduleCron)}
                </button>
                <Button
                    type="primary"
                    disabled={!value.trim() || submitting}
                    showSpinner={submitting}
                    onClick={submit}
                    className={css.addMonitorButton}
                >
                    <Translate id={`${TRANSLATION_KEY}.${addKey}`} />
                </Button>
            </div>
            {error && <div className={css.error}>{error}</div>}
        </div>
    );
};

AddMonitorBar.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    scheduleCron: PropTypes.string.isRequired,
    onScheduleClick: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    error: PropTypes.string,
    isEmptyVariant: PropTypes.bool,
    initialValue: PropTypes.string,
    translate: PropTypes.func.isRequired,
};

export default withLocalize(AddMonitorBar);
